<template>
  <div class="toggle-button-container">
    <div class="toggle-wrapper">
      <button 
        :class="['toggle-btn', 'left-btn', { 'active': activeTab === 'email' }]"
        @click="switchTab('email')"
      >
        {{ emailText }}
      </button>
      <button 
        :class="['toggle-btn', 'right-btn', { 'active': activeTab === 'phone' }]"
        @click="switchTab('phone')"
      >
        {{ phoneText }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ToggleButton',
  props: {
    // 初始激活的选项
    defaultActive: {
      type: String,
      default: 'phone',
      validator: value => ['phone', 'email'].includes(value)
    },
    // 自定义按钮文本
    phoneText: {
      type: String,
      default: '手机注册'
    },
    emailText: {
      type: String,
      default: '邮箱注册'
    }
  },
  data() {
    return {
      activeTab: this.defaultActive
    }
  },
  methods: {
    switchTab(tab) {
      if (this.activeTab !== tab) {
        this.activeTab = tab
        // 向父组件发送切换事件
        this.$emit('change', tab)
      }
    }
  },
  watch: {
    defaultActive: {
      handler(newVal) {
        this.activeTab = newVal
      },
      immediate: true
    }
  }
}
</script>

<style scoped>
.toggle-button-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 6px 20px;
}

.toggle-wrapper {
  display: flex;
  background-color: #f5f5f5;
  border-radius: 12px;
  padding: 4px;
  position: relative;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.toggle-btn {
  padding: 5px 24px;
  border: none;
  background: transparent;
  color: #666;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  border-radius: 11px;
  transition: all 0.3s ease;
  position: relative;
  z-index: 1;
  min-width: 80px;
  outline: none;
}

.toggle-btn:hover {
  color: #333;
}

.toggle-btn.active {
  background-color: #fff;
  color: #333;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  transform: translateY(-1px);
}

.left-btn {
  margin-right: 2px;
}

.right-btn {
  margin-left: 2px;
}

/* 响应式设计 */
@media (max-width: 480px) {
  .toggle-btn {
    padding: 5px 18px;
    font-size: 13px;
    min-width: 70px;
  }
}
</style>